var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-logo-view"},[_c('img',{attrs:{"src":_vm.getResourcePath+_vm.getCustomerId+'/logo/logo.svg'}})])}
var staticRenderFns = []

export { render, staticRenderFns }